import apiClient from '@/services/rest-api-sms/apiClient'

const skillEndpoint = '/technician/skill'
const dayOffEndpoint = '/technician/day-off'

export const getSkills = async () => {
  const response = await apiClient({
    method: 'GET',
    url: skillEndpoint,
  })

  return response?.data
}

export const getTechnicianSkills = async (userId) => {
  const response = await apiClient({
    method: 'GET',
    url: `${skillEndpoint}/${userId}`,
  })

  return response?.data
}

export const saveTechnicianSkill = async (payload) => {
  const response = await apiClient({
    method: 'POST',
    url: skillEndpoint,
    data: payload,
  })

  return response?.data
}

export const getDayOffs = async (params) => {
  const response = await apiClient({
    method: 'GET',
    url: dayOffEndpoint,
    params,
  })

  return response?.data
}

export const createDayOff = async (payload) => {
  const response = await apiClient({
    method: 'POST',
    url: dayOffEndpoint,
    data: payload,
  })

  return response?.data
}

export const deleteDayOff = async (dayOffId) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${dayOffEndpoint}/${dayOffId}`,
  })

  return response?.data
}
